import React from "react";

export default () => {
  return (
    <svg
      width="173px"
      height="121px"
      viewBox="0 0 173 121"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Category B</title>
      <defs>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="cb-linearGradient-1"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M132.369661,0.0100847458 L128,61.9643498 L128,90.2875407 L159.804831,90.2875407 L159.804831,61.9630784 L155.435169,0 C154.951856,0.175449153 132.849661,0.175601695 132.369661,0.0100847458 Z"
          id="cb-path-2"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="cb-linearGradient-3"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <polygon
          id="cb-path-4"
          points="2.52242671e-13 4.28600658e-13 38.9357372 5.62533071e-13 38.9357372 44.9152542 2.52242671e-13 56.779661"
        ></polygon>
        <linearGradient
          x1="50%"
          y1="0.0422252714%"
          x2="50%"
          y2="100%"
          id="cb-linearGradient-5"
        >
          <stop stopColor="#477EB2" offset="0.0211148649%"></stop>
          <stop stopColor="#366088" offset="100%"></stop>
        </linearGradient>
        <linearGradient
          x1="50%"
          y1="0.0422252714%"
          x2="50%"
          y2="100%"
          id="cb-linearGradient-6"
        >
          <stop stopColor="#477EB2" offset="0.0211148649%"></stop>
          <stop stopColor="#366088" offset="100%"></stop>
        </linearGradient>
        <polygon
          id="cb-path-7"
          points="2.52242671e-13 4.28600658e-13 38.9357372 5.62533071e-13 38.9357372 44.9152542 2.52242671e-13 56.779661"
        ></polygon>
        <polygon
          id="cb-path-8"
          points="0 4.71233222e-13 38.9357372 6.05165635e-13 38.9357372 44.9152542 0 56.779661"
        ></polygon>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="cb-linearGradient-9"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <polygon
          id="cb-path-10"
          points="0 0.5 38.9357372 0.5 38.9357372 45.779661 0 45.779661"
        ></polygon>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="99.6199324%"
          id="cb-linearGradient-11"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M30.5084746,8.47457627 L33.8983051,8.47457627 C34.8343809,8.47457627 35.5932203,9.23341568 35.5932203,10.1694915 L35.5932203,20.3389831 L35.5932203,20.3389831 L28.8135593,20.3389831 L28.8135593,10.1694915 C28.8135593,9.23341568 29.5723987,8.47457627 30.5084746,8.47457627 Z"
          id="cb-path-12"
        ></path>
        <path
          d="M38.9830508,8.47457627 L42.3728814,8.47457627 C43.3089572,8.47457627 44.0677966,9.23341568 44.0677966,10.1694915 L44.0677966,20.3389831 L44.0677966,20.3389831 L37.2881356,20.3389831 L37.2881356,10.1694915 C37.2881356,9.23341568 38.046975,8.47457627 38.9830508,8.47457627 Z"
          id="cb-path-13"
        ></path>
        <path
          d="M47.4576271,8.47457627 L50.8474576,8.47457627 C51.7835335,8.47457627 52.5423729,9.23341568 52.5423729,10.1694915 L52.5423729,20.3389831 L52.5423729,20.3389831 L45.7627119,20.3389831 L45.7627119,10.1694915 C45.7627119,9.23341568 46.5215513,8.47457627 47.4576271,8.47457627 Z"
          id="cb-path-14"
        ></path>
        <path
          d="M22.0338983,8.47457627 L25.4237288,8.47457627 C26.3598047,8.47457627 27.1186441,9.23341568 27.1186441,10.1694915 L27.1186441,20.3389831 L27.1186441,20.3389831 L20.3389831,20.3389831 L20.3389831,10.1694915 C20.3389831,9.23341568 21.0978225,8.47457627 22.0338983,8.47457627 Z"
          id="cb-path-15"
        ></path>
        <path
          d="M13.559322,8.47457627 L16.9491525,8.47457627 C17.8852284,8.47457627 18.6440678,9.23341568 18.6440678,10.1694915 L18.6440678,20.3389831 L18.6440678,20.3389831 L11.8644068,20.3389831 L11.8644068,10.1694915 C11.8644068,9.23341568 12.6232462,8.47457627 13.559322,8.47457627 Z"
          id="cb-path-16"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="99.6199324%"
          id="cb-linearGradient-17"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M6.77966102,1.0658141e-13 C7.71573686,1.06409456e-13 8.47457627,0.758839407 8.47457627,1.69491525 L8.47457627,20.3389831 L8.47457627,20.3389831 L5.08474576,20.3389831 L5.08474576,1.69491525 C5.08474576,0.758839407 5.84358517,1.06753365e-13 6.77966102,1.0658141e-13 Z"
          id="cb-path-18"
        ></path>
        <path
          d="M57.6271186,1.0658141e-13 C58.5631945,1.06409456e-13 59.3220339,0.758839407 59.3220339,1.69491525 L59.3220339,20.3389831 L59.3220339,20.3389831 L55.9322034,20.3389831 L55.9322034,1.69491525 C55.9322034,0.758839407 56.6910428,1.06753365e-13 57.6271186,1.0658141e-13 Z"
          id="cb-path-19"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="99.6199324%"
          id="cb-linearGradient-20"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M1,1.69491525 L63.4067797,1.69491525 C63.9590644,1.69491525 64.4067797,2.1426305 64.4067797,2.69491525 L64.4067797,4.08474576 C64.4067797,4.63703051 63.9590644,5.08474576 63.4067797,5.08474576 L1,5.08474576 C0.44771525,5.08474576 -4.12047151e-13,4.63703051 -4.12114787e-13,4.08474576 L-4.12114787e-13,2.69491525 C-4.12182422e-13,2.1426305 0.44771525,1.69491525 1,1.69491525 Z"
          id="cb-path-21"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="cb-linearGradient-22"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M1,116 L172,116 C172.552285,116 173,116.447715 173,117 L173,119.2 C173,119.752285 172.552285,120.2 172,120.2 L1,120.2 C0.44771525,120.2 6.76353751e-17,119.752285 0,119.2 L0,117 C-6.76353751e-17,116.447715 0.44771525,116 1,116 Z"
          id="cb-path-23"
        ></path>
      </defs>
      <g
        id="cb-Wireframe-v4-Layout-v2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="cb-PWA-Desktop-Page2---Access-Categories---b"
          transform="translate(-900.000000, -562.000000)"
        >
          <g id="cb-cat-C" transform="translate(318.000000, 379.000000)">
            <g id="cb-Group-3" transform="translate(1.000000, 67.000000)">
              <g
                id="cb-category-C"
                transform="translate(581.000000, 116.000000)"
              >
                <path
                  d="M139.355932,110.5 L139.355932,67.3761783 C139.355932,64.0624698 136.669641,61.3761783 133.355932,61.3761783 L114.508475,61.3761783 C111.194766,61.3761783 108.508475,64.0624698 108.508475,67.3761783 L108.508475,77.4 L108.508475,77.4"
                  id="cb-Path-7"
                  stroke="#00AEEF"
                  strokeWidth="5.08474576"
                ></path>
                <path
                  d="M139.355932,110.5 L139.355932,67.3761783 C139.355932,64.0624698 136.669641,61.3761783 133.355932,61.3761783 L114.508475,61.3761783 C111.194766,61.3761783 108.508475,64.0624698 108.508475,67.3761783 L108.508475,77.4 L108.508475,77.4"
                  id="cb-Path-7-Copy-2"
                  stroke="#79D4F6"
                  strokeWidth="6.77966102"
                  strokeDasharray="1.694915254237288"
                ></path>
                <g id="cb-Fill-2">
                  <use fill="#00AEEF" href="#cb-path-2"></use>
                  <use
                    fill="url(#cb-linearGradient-1)"
                    style={{ mixBlendMode: "screen" }}
                    href="#cb-path-2"
                  ></use>
                </g>
                <g id="cb-Group-4" transform="translate(10.000000, 60.000000)">
                  <g
                    id="cb-Rectangle-Copy-20"
                    transform="translate(19.467869, 28.389831) scale(1, -1) translate(-19.467869, -28.389831) "
                  >
                    <use fill="#8FD5EF" href="#cb-path-4"></use>
                    <use
                      fill="url(#cb-linearGradient-3)"
                      style={{ mixBlendMode: "screen" }}
                      href="#cb-path-4"
                    ></use>
                  </g>
                  <path
                    d="M5.93220339,8.05918755 L5.93220339,13.1391875 L11.0169492,13.1391875 L11.0169492,8.05918755 L5.93220339,8.05918755 Z M5.93220339,18.2191874 L5.93220339,23.2991873 L11.0169492,23.2991873 L11.0169492,18.2191874 L5.93220339,18.2191874 Z M5.93220339,28.3791872 L5.93220339,33.4591872 L11.0169492,33.4591872 L11.0169492,28.3791872 L5.93220339,28.3791872 Z"
                    id="cb-Path-6"
                    fill="url(#cb-linearGradient-5)"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M16.1016949,18.2542373 L16.1016949,23.3342372 L21.1864407,23.3342372 L21.1864407,18.2542373 L16.1016949,18.2542373 Z M16.1016949,28.4142371 L16.1016949,33.4942371 L21.1864407,33.4942371 L21.1864407,28.4142371 L16.1016949,28.4142371 Z"
                    id="cb-Path-6-Copy"
                    fill="url(#cb-linearGradient-6)"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M26.2711864,18.2542373 L26.2711864,23.3342372 L31.3559322,23.3342372 L31.3559322,18.2542373 L26.2711864,18.2542373 Z M26.2711864,28.4142371 L26.2711864,33.4942371 L31.3559322,33.4942371 L31.3559322,28.4142371 L26.2711864,28.4142371 Z"
                    id="cb-Path-6-Copy-2"
                    fill="url(#cb-linearGradient-6)"
                    fillRule="nonzero"
                  ></path>
                </g>
                <g
                  id="cb-Group-4-Copy"
                  transform="translate(47.983051, 60.000000)"
                >
                  <g
                    id="cb-Rectangle-Copy-20"
                    transform="translate(19.467869, 28.389831) scale(1, -1) translate(-19.467869, -28.389831) "
                  >
                    <use fill="#8FD5EF" href="#cb-path-7"></use>
                    <use
                      fill="url(#cb-linearGradient-3)"
                      style={{ mixBlendMode: "screen" }}
                      href="#cb-path-7"
                    ></use>
                  </g>
                  <path
                    d="M5.93220339,8.05918755 L5.93220339,13.1391875 L11.0169492,13.1391875 L11.0169492,8.05918755 L5.93220339,8.05918755 Z M5.93220339,18.2191874 L5.93220339,23.2991873 L11.0169492,23.2991873 L11.0169492,18.2191874 L5.93220339,18.2191874 Z M5.93220339,28.3791872 L5.93220339,33.4591872 L11.0169492,33.4591872 L11.0169492,28.3791872 L5.93220339,28.3791872 Z"
                    id="cb-Path-6"
                    fill="url(#cb-linearGradient-5)"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M16.1016949,18.2542373 L16.1016949,23.3342372 L21.1864407,23.3342372 L21.1864407,18.2542373 L16.1016949,18.2542373 Z M16.1016949,28.4142371 L16.1016949,33.4942371 L21.1864407,33.4942371 L21.1864407,28.4142371 L16.1016949,28.4142371 Z"
                    id="cb-Path-6-Copy"
                    fill="url(#cb-linearGradient-6)"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M26.2711864,18.2542373 L26.2711864,23.3342372 L31.3559322,23.3342372 L31.3559322,18.2542373 L26.2711864,18.2542373 Z M26.2711864,28.4142371 L26.2711864,33.4942371 L31.3559322,33.4942371 L31.3559322,28.4142371 L26.2711864,28.4142371 Z"
                    id="cb-Path-6-Copy-2"
                    fill="url(#cb-linearGradient-6)"
                    fillRule="nonzero"
                  ></path>
                </g>
                <g
                  id="cb-Group-4-Copy-2"
                  transform="translate(85.983051, 60.000000)"
                >
                  <g
                    id="cb-Rectangle-Copy-20"
                    transform="translate(19.467869, 28.389831) scale(1, -1) translate(-19.467869, -28.389831) "
                  >
                    <use fill="#8FD5EF" href="#cb-path-8"></use>
                    <use
                      fill="url(#cb-linearGradient-3)"
                      style={{ mixBlendMode: "screen" }}
                      href="#cb-path-8"
                    ></use>
                  </g>
                  <path
                    d="M5.93220339,8.05918755 L5.93220339,13.1391875 L11.0169492,13.1391875 L11.0169492,8.05918755 L5.93220339,8.05918755 Z M5.93220339,18.2191874 L5.93220339,23.2991873 L11.0169492,23.2991873 L11.0169492,18.2191874 L5.93220339,18.2191874 Z M5.93220339,28.3791872 L5.93220339,33.4591872 L11.0169492,33.4591872 L11.0169492,28.3791872 L5.93220339,28.3791872 Z"
                    id="cb-Path-6"
                    fill="url(#cb-linearGradient-5)"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M16.1016949,18.2542373 L16.1016949,23.3342372 L21.1864407,23.3342372 L21.1864407,18.2542373 L16.1016949,18.2542373 Z M16.1016949,28.4142371 L16.1016949,33.4942371 L21.1864407,33.4942371 L21.1864407,28.4142371 L16.1016949,28.4142371 Z"
                    id="cb-Path-6-Copy"
                    fill="url(#cb-linearGradient-6)"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M26.2711864,18.2542373 L26.2711864,23.3342372 L31.3559322,23.3342372 L31.3559322,18.2542373 L26.2711864,18.2542373 Z M26.2711864,28.4142371 L26.2711864,33.4942371 L31.3559322,33.4942371 L31.3559322,28.4142371 L26.2711864,28.4142371 Z"
                    id="cb-Path-6-Copy-2"
                    fill="url(#cb-linearGradient-6)"
                    fillRule="nonzero"
                  ></path>
                </g>
                <g
                  id="cb-Group-4-Copy-3"
                  transform="translate(124.000000, 71.000000)"
                >
                  <g
                    id="cb-Rectangle-Copy-20"
                    transform="translate(19.467869, 23.139831) scale(1, -1) translate(-19.467869, -23.139831) "
                  >
                    <use fill="#8FD5EF" href="#cb-path-10"></use>
                    <use
                      fill="url(#cb-linearGradient-9)"
                      style={{ mixBlendMode: "screen" }}
                      href="#cb-path-10"
                    ></use>
                  </g>
                  <path
                    d="M5.93220339,7.25423729 L5.93220339,12.3342372 L11.0169492,12.3342372 L11.0169492,7.25423729 L5.93220339,7.25423729 Z M5.93220339,17.4142371 L5.93220339,22.4942371 L11.0169492,22.4942371 L11.0169492,17.4142371 L5.93220339,17.4142371 Z"
                    id="cb-Path-6"
                    fill="url(#cb-linearGradient-6)"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M16.1016949,7.25423729 L16.1016949,12.3342372 L21.1864407,12.3342372 L21.1864407,7.25423729 L16.1016949,7.25423729 Z M16.1016949,17.4142371 L16.1016949,22.4942371 L21.1864407,22.4942371 L21.1864407,17.4142371 L16.1016949,17.4142371 Z"
                    id="cb-Path-6-Copy"
                    fill="url(#cb-linearGradient-6)"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M26.2711864,7.25423729 L26.2711864,12.3342372 L31.3559322,12.3342372 L31.3559322,7.25423729 L26.2711864,7.25423729 Z M26.2711864,17.4142371 L26.2711864,22.4942371 L31.3559322,22.4942371 L31.3559322,17.4142371 L26.2711864,17.4142371 Z"
                    id="cb-Path-6-Copy-2"
                    fill="url(#cb-linearGradient-6)"
                    fillRule="nonzero"
                  ></path>
                </g>
                <g id="cb-Group-6" transform="translate(54.000000, 96.000000)">
                  <g id="cb-Rectangle-Copy-26">
                    <use fill="#487FB4" href="#cb-path-12"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#cb-linearGradient-11)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#cb-path-12"
                    ></use>
                  </g>
                  <g id="cb-Rectangle-Copy-27">
                    <use fill="#487FB4" href="#cb-path-13"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#cb-linearGradient-11)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#cb-path-13"
                    ></use>
                  </g>
                  <g id="cb-Rectangle-Copy-30">
                    <use fill="#487FB4" href="#cb-path-14"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#cb-linearGradient-11)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#cb-path-14"
                    ></use>
                  </g>
                  <g id="cb-Rectangle-Copy-28">
                    <use fill="#487FB4" href="#cb-path-15"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#cb-linearGradient-11)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#cb-path-15"
                    ></use>
                  </g>
                  <g id="cb-Rectangle-Copy-29">
                    <use fill="#487FB4" href="#cb-path-16"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#cb-linearGradient-11)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#cb-path-16"
                    ></use>
                  </g>
                  <g id="cb-Rectangle-Copy-24">
                    <use fill="#487FB4" href="#cb-path-18"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#cb-linearGradient-17)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#cb-path-18"
                    ></use>
                  </g>
                  <g id="cb-Rectangle-Copy-25">
                    <use fill="#487FB4" href="#cb-path-19"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#cb-linearGradient-17)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#cb-path-19"
                    ></use>
                  </g>
                  <g id="cb-Rectangle-Copy-21">
                    <use fill="#487FB4" href="#cb-path-21"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#cb-linearGradient-20)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#cb-path-21"
                    ></use>
                  </g>
                </g>
                <g
                  id="cb-Rectangle-Copy-37"
                  transform="translate(86.499998, 118.100000) scale(1, -1) translate(-86.499998, -118.100000) "
                >
                  <use fill="#00AEEF" href="#cb-path-23"></use>
                  <use
                    fill="url(#cb-linearGradient-22)"
                    style={{ mixBlendMode: "screen" }}
                    href="#cb-path-23"
                  ></use>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
